import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import GridView from '../../../components/elements/GridView/index';
import { formatTimesheetReportData } from '../../../core/utils/reportUtils';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import CustomEmpty from '../../../components/CustomEmpty';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../components/Spinner';

class AssetJourneyHistoryTab extends Component {
    componentDidMount() {
        if (!this.props.assetJourneyTabLoaded) {
            this.props.setLoadedState();
        }
    }

    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;

        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const {
            onTableChange,
            assetJourneysPagination,
        } = this.props;

        if (pagination && pagination.current === assetJourneysPagination.currentPage) {
            onTableChange(pagination, filters, sorter, extra);
        }
    };

    render() {
        const {
            assetJourneys,
            assetJourneysPagination,
            isLoadingAssetJourneys,
            isExportingAssetJourneyCsv,
            onExportAssetJourneyCSV,
            singleAsset,
            uomPreference,
            companyFeatures,
        } = this.props;

        if (singleAsset && singleAsset.act_as_tracker) {
            return (
                <div className="h-centered-text-container">
                    <p>
                        Unavailable for this Asset — 
                        &thinsp;
                        <a 
                            href="https://www.fleetclear.com/contact" 
                            target="_blank" 
                            rel="noreferrer"
                        >
                            Click Here
                        </a>
                        &thinsp;
                        to find out more
                    </p>
                </div>
            );
        }
        if (!assetJourneys || assetJourneys.length === 0 && !isLoadingAssetJourneys) {
            return <CustomEmpty />;
        }

        const list = formatTimesheetReportData(assetJourneys, uomPreference, 'journeys', isExportingAssetJourneyCsv, companyFeatures);

        return (
            <>
                <Spinner 
                    loading={isLoadingAssetJourneys} 
                    minHeight={200}
                >
                    {assetJourneys && assetJourneys.length > 0 && (
                        <>
                            <Button
                                type="primary"
                                className="export-csv-button"
                                onClick={onExportAssetJourneyCSV}
                                style={{ marginBottom: '16px' }}
                                loading={isExportingAssetJourneyCsv}
                                data-testid='asset-details-journeys_export-btn'
                            >
                                Export
                            </Button>
                            <br/>
                        </>
                    )}
                    <div style={{ opacity: isLoadingAssetJourneys ? 0 : 1 }}>
                        <GridView
                            data={list && list.length > 0 ? list : []}
                            onChange={this.onTableChange}
                            sortableColumns={[
                                'driver',
                                'division',
                                'registration',
                                'start_date',
                                'end_date',
                                'shift',
                                'time_driven',
                                'idle_time',
                                'true_idle',
                                'mileage_Km',
                                'avg_speed_Km',
                                'max_speed_Km',
                            ]}
                            hiddenColumns={['id', 'asset_id', 'driver_id', 'action']}
                            pagination={{
                                total: parseInt(assetJourneysPagination.totalRecords, 10),
                                showSizeChanger: false,
                                pageSize: parseInt(assetJourneysPagination.perPageCount, 10),
                                current: parseInt(assetJourneysPagination.currentPage, 10),
                                onChange: this.onPageChange,
                                showTotal: getPaginationTotal,
                            }}
                        />
                    </div>
                </Spinner>
            </>
        );
    }
}

AssetJourneyHistoryTab.propTypes = {
    assetJourneys: PropTypes.array,
    assetJourneysPagination: PropTypes.shape({
        currentPage: PropTypes.number,
        perPageCount: PropTypes.number,
        totalRecords: PropTypes.number,
    }),
    isLoadingAssetJourneys: PropTypes.bool,
    isExportingAssetJourneyCsv: PropTypes.bool,
    onExportAssetJourneyCSV: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onTableChange: PropTypes.func.isRequired,
    assetJourneyTabLoaded: PropTypes.bool,
    setLoadedState: PropTypes.func,
    singleAsset: PropTypes.object,
};

AssetJourneyHistoryTab.defaultProps = {
    assetJourneys: [],
    assetJourneysPagination: {
        currentPage: 1,
        perPageCount: 10,
        totalRecords: 0,
    },
    isLoadingAssetJourneys: false,
    isExportingAssetJourneyCsv: false,
    assetJourneyTabLoaded: false,
    setLoadedState: () => {
    },
    singleAsset: {},
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        isFetching: state.report.isFetching,
        timeSheetReport: state.report.timeSheetReport,
        timeSheetReportPagination: state.report.timeSheetReportPagination,
        assetJourneyFilters: state.asset.assetJourneyFilters,
        uomPreference: state.user.profile.unit_of_measurement_preference,
        companyFeatures: state.user.userCompany.features,
        isExportingTimesheetReportCsv: state.report.isExportingTimesheetReportCsv,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({}, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssetJourneyHistoryTab);
